export enum UserTypeEnum {
    AdminUser = 1,
    Cashier = 2,
    System = 3,
    MasterAgent = 4,
    Agent = 5,
    AgentEmployee= 6
}
